import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });

export const createLead = (data) => http.post("/leads", data).then((r) => r.data);
export const fetchLeads = () => http.get("/leads").then((r) => r.data);
export const fetchLeadStats = () => http.get("/leads/stats").then((r) => r.data);
export const updateLeadStatus = (id, status) => http.patch(`/leads/${id}`, { status }).then((r) => r.data);
export const deleteLead = (id) => http.delete(`/leads/${id}`);

export const login = (password) => http.post("/auth/login", { password }).then((r) => r.data);
export const fetchMe = () => http.get("/auth/me").then((r) => r.data);
export const logout = () => http.post("/auth/logout");

export const formatApiError = (detail, fallback) => {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg?.replace("Value error, ", "")).filter(Boolean).join(" ");
  return detail.msg || fallback;
};

export const REWARD_CODE = "BONO50AUTO";
export const BRAND = {
  name: "Mi Protección 365",
  logo: "/fb_logo.jpg",
  tagline: "Protégete a ti y a tu familia hoy y construye tu futuro de la mejor manera",
  badge: "PROTECCIÓN · CRECIMIENTO · LEGADO",
  facebook: "https://www.facebook.com/share/1DaAZ9c8mZ/",
};
